import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LoadingSpinner from "../loading/LoadingSpinner";

const TypeTour = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Danh sách ảnh mặc định
  const defaultImages = [
    "assets/img/tours/tours-01.jpg",
    "assets/img/tours/tours-02.jpg",
    "assets/img/tours/tours-03.jpg",
    "assets/img/tours/tours-04.jpg",
    "assets/img/tours/tours-05.jpg",
    "assets/img/tours/tours-06.jpg",
    "assets/img/tours/tours-07.jpg",
    "assets/img/tours/tours-08.jpg",
    "assets/img/tours/tours-09.jpg",
    "assets/img/tours/tours-10.jpg",
    "assets/img/tours/tours-11.jpg",
    "assets/img/tours/tours-12.jpg",
    "assets/img/tours/tours-13.jpg",
    "assets/img/tours/tours-14.jpg",
    "assets/img/tours/tours-15.jpg",
  ];

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://tourvn.runasp.net/api/categories/get-categories-with-tour-count"
        );
        setCategories(response.data.data);
        setLoading(false);
      } catch (err) {
        setError("Không thể tải danh sách danh mục.");
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) {
    return (
      <p>
        <LoadingSpinner
          type="circle"
          color="#3498db"
          size={30}
          text="Đang tải dữ liệu..."
        />
      </p>
    );
  }

  if (error) {
    return <p className="text-danger">{error}</p>;
  }

  // Cấu hình slider
  const settings = {
    dots: false, // Ẩn chấm
    infinite: true, // Vòng lặp vô hạn
    speed: 800, // Thời gian chuyển slide (ms)
    slidesToShow: Math.min(6, categories.length), // Hiển thị tối đa 6 category
    slidesToScroll: 1, // Di chuyển từng category một
    autoplay: true, // Tự động di chuyển
    autoplaySpeed: 2000, // Thời gian dừng trước khi chuyển slide (ms)
    pauseOnHover: false, // Không dừng khi hover vào
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4, slidesToScroll: 1 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 3, slidesToScroll: 1 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  return (
    <div className="mb-2">
      <div className="mb-3">
        <h5 className="mb-2">Chọn loại tour bạn quan tâm</h5>
      </div>
      <Slider {...settings}>
        {categories.map((category, index) => (
          <div key={category.id} className="px-2">
            <div className="d-flex align-items-center hotel-type-item mb-3">
              <Link
                to={`/tour-list?categoryId=${category.id}`}
                className="avatar avatar-lg"
              >
                <img
                  src={defaultImages[index % defaultImages.length]} // Gán ảnh theo thứ tự
                  className="rounded-circle"
                  alt={category.name}
                  style={{ width: "100px", height: "100px" }}
                />
              </Link>
              <div className="ms-2">
                <h6 className="fs-16 fw-medium">
                  <Link to={`/tour-list?categoryId=${category.id}`}>
                    {category.name}
                  </Link>
                </h6>
                <p className="fs-14">{category.tourCount} tours</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TypeTour;
